export const isMaintenance = (account_id) => {
    var res = false;
    if (process.env.REACT_APP_MAINTENANCE === 'true') {
        res = true;
    }

    return res;
}